import { render, staticRenderFns } from "./TffaSettings.vue?vue&type=template&id=5d4da941&scoped=true"
import script from "./TffaSettings.vue?vue&type=script&lang=js"
export * from "./TffaSettings.vue?vue&type=script&lang=js"
import style0 from "./TffaSettings.vue?vue&type=style&index=0&id=5d4da941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4da941",
  null
  
)

export default component.exports